<template>
  <div>
    <LineOaButton />
  </div>
</template>

<script>
import liff from "@line/liff";
import https from "@/apis/liff/v2/https";
import LineOaButton from "@/components/Page/Liff/LineOaButton.vue";

export default {
  components: { LineOaButton },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.orgCode = this.$route.params.orgCode;
      let templateCode = this.$route.params.template_code;
      if (!templateCode) {
        liff.closeWindow();
        this.$swal.fire('錯誤', '網址錯誤', 'error');
        return;
      }

      // 把網址裡的 query parameter 整理起來，連同 templateCode 一起送去後端做推播
      templateCode = templateCode.toUpperCase();
      let params = new URL(location.href).searchParams;
      let payload = {
        template_code: templateCode,
        params: Object.fromEntries(params.entries())
      };
      console.log(payload);
      try {
        let response = await https.post(`${this.orgCode}/liff/line-push`, payload);
        console.log(response);
        // liff.closeWindow();
      } catch (error) {
        console.error(error);
        this.$swal.fire('錯誤', '推播失敗', 'error');
        // liff.closeWindow();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.line-push {
  background-color: #2ba039;
  color: white;
  height: 40px;
}
</style>
